export const NewsletterID: string = "AGGRWEBAGGR_WEB_MEOPM";
export const NewsletterIDD2D: string = "AGGROSPAGGR_D2D_MEOPM";
export const NewsletterType: string = "EOPM";

export const GdprID: string = "AGGRWEBAGGR_WEB_MGDPR01";
export const GdprIDD2D: string = "AGGROSPAGGR_D2D_MGDPR01";
export const GdprType: string = "GDPR01";

export const ChannelIdWeb = "WEB";
